import Vue from "vue"
import Vuex from "vuex"
import random from "lodash.random"

import RW from "@/utils/randomWeight"
Vue.use(Vuex)

const sortArea = (a, b) => {
  return a.sortOrder - b.sortOrder
}

const SUM = (accumulator, currentValue) => accumulator + currentValue
import AreasDataset from "@/data/areas.json"
const land = [...new Set(AreasDataset.map(x => x.g))].map(x => ({
  id: x,
  areas: AreasDataset.filter(y => y.g == x).map(y => y.id)
}))
export default new Vuex.Store({
  state: {
    teams: [
      { id: 10, label: "alpha", color: "lightblue", isHuman: true },
      { id: 12, label: "beta", color: "#ffcf78", isHuman: true },
      { id: 14, label: "gamma", color: "#bada55", isHuman: false },
      { id: 16, label: "delta", color: "#f26464", isHuman: false }
    ],
    areas: AreasDataset,
    land,
    game: {
      turn: 0,
      isFirstTurn: true,
      level: -1,
      startSize: -1,
      teams: 4,
      breakdown: [
        { areaId: 101, teamId: 10, size: 1 },
        { areaId: 102, teamId: 14, size: 3 },
        { areaId: 103, teamId: 10, size: 14 },
        { areaId: 104, teamId: 12, size: 4 },
        { areaId: 105, teamId: 16, size: 2 },
        { areaId: 106, teamId: 12, size: 5 },
        { areaId: 107, teamId: 10, size: 5 },
        { areaId: 108, teamId: 14, size: 3 },
        { areaId: 109, teamId: 10, size: 4 },
        { areaId: 110, teamId: 12, size: 4 },
        { areaId: 111, teamId: 10, size: 5 },
        { areaId: 112, teamId: 14, size: 3 },
        { areaId: 113, teamId: 10, size: 4 },
        { areaId: 114, teamId: 12, size: 4 },
        { areaId: 115, teamId: 16, size: 2 },
        { areaId: 116, teamId: 12, size: 5 },
        { areaId: 117, teamId: 10, size: 5 },
        { areaId: 118, teamId: 14, size: 3 },
        { areaId: 119, teamId: 10, size: 4 },
        { areaId: 120, teamId: 12, size: 4 },
        { areaId: 121, teamId: 10, size: 5 },
        { areaId: 122, teamId: 14, size: 3 },
        { areaId: 123, teamId: 10, size: 4 },
        { areaId: 124, teamId: 12, size: 4 },
        { areaId: 125, teamId: 16, size: 2 },
        { areaId: 126, teamId: 12, size: 5 },
        { areaId: 127, teamId: 10, size: 5 },
        { areaId: 128, teamId: 14, size: 3 },
        { areaId: 129, teamId: 10, size: 4 },
        { areaId: 130, teamId: 12, size: 4 },
        { areaId: 131, teamId: 10, size: 5 },
        { areaId: 132, teamId: 14, size: 3 },
        { areaId: 133, teamId: 10, size: 4 },
        { areaId: 134, teamId: 12, size: 4 },
        { areaId: 135, teamId: 16, size: 2 },
        { areaId: 136, teamId: 12, size: 5 },
        { areaId: 137, teamId: 10, size: 5 },
        { areaId: 138, teamId: 14, size: 3 },
        { areaId: 139, teamId: 10, size: 4 },
        { areaId: 140, teamId: 10, size: 4 },
        { areaId: 141, teamId: 16, size: 2 },
        { areaId: 142, teamId: 12, size: 5 },
        { areaId: 143, teamId: 12, size: 4 }
      ]
    }
  },
  getters: {
    bestAttack: (state, getters) => teamid => {
      let getProxies = item => {
        let id = item.areaId
        let result = getters
          .getTargets(id, teamid)
          .map(x => state.game.breakdown.find(y => y.areaId === x.id))
          .map(x => ({
            source: {
              id: item.areaId,
              size: item.size,
              teamId: x.teamId
            },
            target: {
              id: x.areaId,
              size: x.size,
              teamId: x.teamId
            },
            land: state.areas.find(x => x.id === id).g,
            perc: Math.ceil((item.size / (item.size + x.size)) * 100)
          }))

        return result
      }

      let targets = []
      getters.activeTeamAreas.forEach(x => {
        targets.push(...getProxies(x))
      })

      targets.sort((a, b) => b.perc - a.perc)
      console.log(targets)
      return targets
    },
    activeTeam: state => {
      var t = state.game.turn
      return t === -1 ? null : state.teams[t]
    },
    
    activeTeamAreas: (state, getters) => {
      return getters.map.filter(x => x.teamId === getters.activeTeam.id)
    },
    map: state => {
      let teams = state.teams
      let areas = state.areas
      return state.game.breakdown
        .map(x => {
          var t = teams.find(y => y.id == x.teamId)
          var i = areas.findIndex(y => y.id == x.areaId)
          var a = areas[i]
          return {
            teamId: x.teamId,
            team: t,
            areaId: x.areaId,
            area: a,
            sortOrder: i,
            size: x.size
          }
        })
        .sort(sortArea)
    },
    getTeamTally: state => teamId => {
      return state.game.breakdown.filter(x => x.teamId === teamId).reduce(SUM)
    },
    getTeamAward: (state, getters) => teamId => {
      getters.getTeamTally(teamId)
    },
    getTargets: (state, getters) => (areaId, teamId) => {
      let item = getters.getArea(areaId)
      // get team members
      let ex = getters.map.filter(x => x.team.id == teamId).map(x => x.area.id)

      return item.area.p
        .map(x => state.areas.find(y => y.id === x))
        .filter(x => !ex.includes(x.id))
    },
    getArea: (state, getters) => areaId => {
      var r = getters.map.find(x => x.areaId === +areaId)

      return r
    },
    getTeamDetails: state => teamId => {
      return state.teams.find(x => x.id === teamId)
    }
  },
  mutations: {
    advanceTurn(state) {
      if (state.game.turn === state.teams.length - 1) state.game.turn = 0
      else state.game.turn++
    },
    updateBoard(state, { areaId, teamId, size }) {
      console.log("updateBoard: ", { areaId, teamId, size })
      var x = state.game.breakdown.find(x => x.areaId === areaId)
      if (size) x.size = size
      if (teamId) x.teamId = teamId
    },
    updateStartSize(state, value) {
      state.game.startSize = value
    },
    setLevel(state, value) {
      state.game.level = value
    },
    updateAreaSize(state, { areaId, value }) {
      var x = state.game.breakdown.find(x => x.areaId === areaId)
      x.size = value
    },
    transferAreaSize(state, { from, to, value }) {
      var f = state.game.breakdown.find(x => x.areaId === from)
      let t = state.game.breakdown.find(x => x.areaId === to)

      f.size -= value
      t.size += value
    },
    setTurn(state, value) {
      state.game.turn = value
    }
  },
  actions: {
    addMembers(state) {
      state.getters.getTeamTally()
    },
    playerAttack(context, { from, to }) {
      let getDetails = (a, offset = 1) => {
        var attackValue = +random(1, Math.floor(a.size / offset), false)

        console.log({
          item: a,
          s: a.size,
          a: attackValue,
          v: a.size - attackValue,
          offset
        })

        return { item: a, s: a.size, a: attackValue, v: a.size - attackValue }
      }

      var f = context.getters.map.find(x => x.area.id == from)
      var t = context.getters.map.find(x => x.area.id == to)

      let offset = f.size > t.size ? 2 : 1

      let { v: fv, s: fs, a: fa } = getDetails(f, offset)
      let { v: tv, s: ts, a: ta } = getDetails(t)

      if (fv <= 1) {
        console.log("LOST")
        // lost
        context.commit("updateBoard", {
          areaId: from,
          teamId: t.team.id,
          size: 1
        })
        context.commit("updateBoard", {
          areaId: to,
          teamId: t.team.id,
          size: tv === 0 ? 1 : tv
        })
      } else if (tv <= 0) {
        console.log("WON")
        context.commit("updateBoard", {
          areaId: from,
          teamId: f.team.id,
          size: fv === 0 ? 1 : fv
        })
        context.commit("updateBoard", {
          areaId: to,
          teamId: f.team.id,
          size: 1
        })
      } else {
        console.log("ONGOING")
        //if (fv == 0 && tv === 0) {
        // both died ... make from winner
        context.commit("updateBoard", {
          areaId: from,
          teamId: f.team.id,
          size: fv
        })
        context.commit("updateBoard", {
          areaId: to,
          teamId: t.team.id,
          size: tv
        })
      }
      //} else {
      //}
    },
    botAttack(context) {}
  }
})
